import styled from "styled-components";
import {KatAlert, KatButton} from "@amzn/katal-react";

export const LogoButton = styled(KatButton)`
    --background-hover: none;
    --hover-ring-color: transparent;
    --box-shadow: none;
    --background: none;
    text-align: center;
    display: flex;
    justify-content: center;
    width: 20%;
    margin: 0 auto !important;
`

export const Heading = styled.h2`
`

export const Body = styled.div`
    text-align: justified;
    display: flex;
    justify-content: justified;
`

export const ConfigPanelButton = styled(LogoButton)`
`

export const FeatureGenerationButton = styled(LogoButton)`
`

export const RunwaysButton = styled(LogoButton)`
`

export const ExperimentsButton = styled(LogoButton)` 
`

export const WelcomeBanner = styled(KatAlert)`
    order: 0;
    vertical-align: center;
    justify-content: center;
    max-width: 98vw;
    width: 98vw;
    margin: 0 auto !important;
    left: 0;
    right: 0;
    position: relative;
`

export const MLTrainingBox = styled.div`
    display: flex;
    justify-content: center;
    border: 2px solid black;
    width: 75vw;
    cursor: pointer;
`

export const LearnMoreLink = styled.a`
    font-size: 10px;
    padding: 1px;
`

export const MainWrapper = styled.div`
    display: flex;
    flex-direction: column;
`

export const SubWrapper = styled.div`
    display: flex;
    justify-content: center;
`